import { gql } from '@apollo/client';

export const CREATE_CALENDAR_EVENT = gql`
  mutation CreateCalendarEvent($input: CalendarEventInput) {
    createCalendarEvent(input: $input) {
      data {
        id
      }
      message
    }
  }
`;

export const UPDATE_CALENDAR_EVENT = gql`
  mutation UpdateCalendarEvent($id: ID!, $input: CalendarEventInput) {
    updateCalendarEvent(id: $id, input: $input) {
      message
    }
  }
`;

export const DELETE_CALENDAR_EVENT = gql`
  mutation DeleteCalendarEvent($id: ID!) {
    deleteCalendarEvent(id: $id) {
      message
    }
  }
`;
